import dropdownDirective from 'Site/directive/dropdown';
import Impressions from 'Site/js/util/impressions';
import AdvertCard from 'Adverts/component/AdvertCard.vue';
import { mapState } from 'vuex';
import Media from 'Media/component/Media.vue';
import PaginationValidation from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import store from 'Site/js/store';
import Vue from 'vue';

export default {
    'addys-advert': () => {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'advertPage',
            store,
            components: {
                Media
            },
            computed: {
                ...mapState(['t']),
                ...mapState({
                    media: state => state.config.data.media
                })
            },
            methods: {
                deleteAdvert(e) {
                    const url = e.currentTarget.getAttribute('href');
                    this.$store.dispatch('showConfirm', {
                        text: this.t.confirm_delete,
                        callback() {
                            window.location.href = url;
                        }
                    });
                },
                showMediaViewer(index) {
                    this.$store.dispatch('showMediaViewer', { media: this.media, start: index });
                }
            },
            mounted() {
                this.$nextTick(() => {
                    new Impressions('.impress-image', 'Advert');
                    new Impressions('.profile-avatar', 'Advert');
                });
            }
        });
    },
    'addys-filter': () => {
        if (document.getElementById('addys-filter-body')) {
            new Vue({
                el: '#addys-filter-body',
                name: 'AddysFilter',
                store,
                components: {
                    AdvertCard
                },
                data() {
                    return {
                        t: store.state.config.t
                    };
                },
                directives: {
                    dropdown: dropdownDirective
                },
                mixins: [PaginationValidation, PromptSignup]
            });
        }
    }
};
